import React from "react";
import API from "../../../services/api.jsx";
import Helpers from "../../../services/helpers.jsx";
import Loader from "../../layout/loader.jsx";
import Head from "../../layout/head.jsx";
import Content from "../../layout/content.jsx";
import CampaignForm from "../../campaigns/form.jsx";
import { toast } from "react-toastify";
import moment from "moment";
import { setDatesToFullDayRange } from "../../../services/campaign.js";

class CampaignsList extends React.Component {
  constructor(props) {
    super(props);
    const searchParams = new URLSearchParams(this.props.location.search);
    const from = searchParams.get("from");

    this.state = {
      loaded: false,
      from,
      breadcrumb: {
        title: "Campaigns list",
        path:
          from === "campaigns"
            ? "/campaigns"
            : "/clients/" + props.match.params.clientId + "/campaigns",
      },
      devices: {
        columns: [
          {
            label: "Device name",
            key: "name",
          },
          {
            label: "SKU",
            key: "sku",
          },
          {
            label: "Status",
            key: "lastPing",
            view: function (field) {
              if (!field) return <div className="red">offline</div>;

              let timestamp = +new Date(field);
              let now = +new Date();
              return now - timestamp > 60 * 60 * 1000 ? (
                <div className="red">offline</div>
              ) : (
                <div className="green">online</div>
              );
            },
          },
          {
            label: "Storage left",
            key: "storage",
            view: function (field) {
              if (!field) return "-";
              return (
                Helpers.formatBytes(field.externalAvailable) +
                "/" +
                Helpers.formatBytes(field.externalTotal)
              );
            },
          },
          {
            label: "Playing",
            key: "playing",
          },
          {
            label: "Timezone",
            key: "timezone",
          },
          {
            label: "Software version",
            key: "softwareVersion",
          },
          {
            label: "Download status",
            key: "downloadStatus",
            view: function (field) {
              if (!field) return "-";
              else if (field.downloaded === field.total)
                return (
                  <div className="progress green">
                    <i className="icon-done"></i> Downloaded
                  </div>
                );
              else
                return (
                  <div className="progress orange">
                    <i className="icon-downloading"></i>{" "}
                    {Math.round(field.downloaded / field.total)}% (
                    {field.downloaded}/{field.total} tracks)
                  </div>
                );
            },
          },
        ],
        entities: [],
        filters: [],
        actions: [],
        selectedItems: [],
        multiSelect: true,
      },
      livePlaylists: {
        columns: [
          {
            label: "Playlist name",
            key: "name",
          },
          {
            label: "Hidden in manual",
            key: "hidden",
            view: function (field) {
              if (!field || field === false) {
                return "False";
              } else {
                return "True";
              }
            },
          },
        ],
        entities: [],
        filters: [],
        actions: [],
        selectedItems: [],
        multiSelect: false,
      },
      manualPlaylists: {
        columns: [
          {
            label: "Playlist name",
            key: "name",
          },
          {
            label: "Tracks",
            key: "assets",
            view: function (field) {
              if (!field) return "-";
              return field.length;
            },
          },
          {
            label: "Duration",
            key: "duration",
            view: function (field) {
              if (!field) return "-";

              return Helpers.formatTime(field);
            },
          },
          {
            label: "Vox tag",
            key: "tag",
          },
          {
            label: "Type",
            key: "type",
            view: (field) => {
              return Helpers.getPlaylistTypeLabel(field);
            },
          },
          {
            label: "Created",
            key: "createdAt",
            view: function (field) {
              return moment(field).format("l");
            },
          },
          {
            label: "Updated",
            key: "updatedAt",
            view: function (field) {
              return moment(field).format("l");
            },
          },
          {
            action: "delete",
            onClick: (id, key) => {
              var r = window.confirm(
                "Are you sure you want to remove this playlist?"
              );
              if (r === false) return;

              let playlists = [...this.state.manualPlaylists.entities];
              playlists.splice(key, 1);
              this.setState({
                ...this.state,
                manualPlaylists: {
                  ...this.state.manualPlaylists,
                  entities: playlists,
                },
              });
            },
          },
        ],
        entities: [],
        filters: [],
        actions: [
          {
            classList: "blue add",
            label: "Add manual playlist",
            onClick: (e) => {},
          },
        ],
        selectedItems: [],
        multiSelect: false,
      },
      campaign: null,
      playlists: [],
      collections: [],
    };
    this.saveEntity = this.saveEntity.bind(this);
  }

  componentDidMount() {
    const clientId = this.props.match.params.clientId;
    const searchParams = new URLSearchParams(this.props.location.search);
    const copyFrom = searchParams.get("copyFrom");
    console.log("[Create new Campaign Copy from Campaign Id]:", copyFrom);
    if (copyFrom) {
      Promise.all([
        API.getCampaign(copyFrom),
        API.getAvaliableOptions('playlists'),
        API.getAvaliableOptions('collections'),
      ]).then(([campaign, playlistsRaw, collectionsRaw]) => {
        const playlists = playlistsRaw?.playlists || [];
        const collections = collectionsRaw?.collections || [];

        setTimeout(() => {
          API.getDevices({ client: clientId }).then((devices) => {
            let tmpLivePlaylists = [];
            let manualPlaylists = [];
            let playlistsIndex = playlists.map((p) => p.id);
            if (campaign && campaign.manualPlaylists) {
              campaign.manualPlaylists.forEach((id) => {
                const playlistIndex = playlistsIndex.indexOf(id);
                if (playlistIndex !== -1) {
                  let manualPlaylist = playlists[playlistIndex];
                  if (manualPlaylist) {
                    campaign.manualPlaylistSettings.forEach(
                      (manualPlaylistSetting) => {
                        if (manualPlaylistSetting.playlist === id) {
                          manualPlaylist.name = manualPlaylistSetting.name;
                        }
                      }
                    );
                    manualPlaylists.push(manualPlaylist);
                  }
                }
              });
            }
            if (campaign.schedules) {
              let newLivePlaylists = [];
              campaign.schedules.forEach((schedule) => {
                if (schedule.playlist) {
                  playlists.forEach((playlists) => {
                    if (playlists.id === schedule.playlist) {
                      newLivePlaylists.push(playlists);
                    }
                  });
                }

                if (schedule.playlistCollection) {
                  collections.forEach((collection) => {
                    if (collection.id === schedule.playlistCollection) {
                      if (Array.isArray(collection.playlists)) {
                        collection.playlists.forEach((collectionPlaylist) => {
                          if (collectionPlaylist?.id) {
                            const authorizedPlaylist = playlists.find(
                              (playlist) => playlist.id === collectionPlaylist.id
                            );
                            if (authorizedPlaylist) {
                              newLivePlaylists.push(authorizedPlaylist);
                            }
                          }
                        });
                      }
                    }
                  });
                }
              });

              let obj = {};
              newLivePlaylists.forEach((newLivePlaylist) => {
                if (!obj[newLivePlaylist.id]) {
                  let livePlaylist = {};
                  let found = false;
                  campaign.manualPlaylistSettings.forEach(
                    (manualPlaylistSetting) => {
                      if (
                        manualPlaylistSetting.playlist === newLivePlaylist.id
                      ) {
                        found = true;
                        livePlaylist.id = manualPlaylistSetting.id;
                        livePlaylist.name = manualPlaylistSetting.name;
                        livePlaylist.hidden = manualPlaylistSetting.hidden;
                        livePlaylist.playlist = manualPlaylistSetting.playlist;
                      }
                    }
                  );
                  if (found === false) {
                    livePlaylist.id = newLivePlaylist.id;
                    livePlaylist.name = newLivePlaylist.name;
                    livePlaylist.playlist = newLivePlaylist.id;
                  }
                  tmpLivePlaylists.push(livePlaylist);
                  obj[newLivePlaylist.id] = true;
                }
              });
            }
            const state = {
              ...this.state,
              campaign: {
                ...Helpers.DEFAULT_NEW_CAMPAIGN,
                client: clientId,
                schedules: campaign?.schedules || [],
                manualPlaylistSettings: campaign?.manualPlaylistSettings || [],
                manualPlaylists: campaign?.manualPlaylists || [],
                infinite: campaign?.infinite,
                startDate: campaign?.startDate,
                endDate: campaign?.endDate,
                downloadDate: campaign?.downloadDate,
                nextUpdateFrequency: campaign?.nextUpdateFrequency,
                name: `Copy of ${campaign?.name || ''}`,
              },
              playlists,
              collections,
              manualPlaylists: {
                ...this.state.manualPlaylists,
                entities: manualPlaylists,
              },
              livePlaylists: {
                ...this.state.livePlaylists,
                entities: tmpLivePlaylists,
              },
              devices: {
                ...this.state.devices,
                entities: devices?.data || [],
              },
              loading: false,
            };
            this.setState(state);
          });
        }, 100);
      });
    } else {
      Promise.all([
        API.getDevices({ client: this.props.match.params.clientId }),
        API.getAvaliableOptions('playlists'),
        API.getAvaliableOptions('collections'),
      ]).then(([devicesRaw, playlistsRaw, collectionsRaw]) => {
        const devices = devicesRaw?.data || [];
        const playlists = playlistsRaw?.playlists || [];
        const collections = collectionsRaw?.collections || [];

        this.setState({
          campaign: {
            ...Helpers.DEFAULT_NEW_CAMPAIGN,
            client: this.props.match.params.clientId,
          },
          devices: {
            ...this.state.devices,
            entities: devices,
          },
          playlists,
          collections,
          loading: false,
        });
      });
    }
  }

  saveEntity(fields, schedules) {
    this.setState({ loading: true });

    fields.devices = [];
    this.state.devices.selectedItems.forEach((value, key) => {
      // console.log(this.state.devices, key)
      if (value) fields.devices.push(this.state.devices.entities[key].id);
    });

    fields.manualPlaylists = this.state.manualPlaylists.entities.map(
      (e) => e.id
    );

    setDatesToFullDayRange(fields);

    const searchParams = new URLSearchParams(this.props.location.search);
    const copyFrom = searchParams.get("copyFrom");
    const normalizedSchedules = (schedules || [])
      .filter((s) => !s.deleted)
      .map((schedule) => {
        const payload = { ...schedule };
        if (payload.playlist && payload.playlist.id) {
          payload.playlist = payload.playlist.id;
        }
        if (payload.playlistCollection) {
          const col = payload.playlistCollection;
          payload.playlistCollection = col.id || col;
        }
        // 创建场景无需传 campaign id；复制场景强制创建新 schedule
        delete payload.campaign;
        if (!!copyFrom) {
          payload.id = undefined;
        }
        return payload;
      });

    API.createCampaignWithSchedules(fields, normalizedSchedules)
      .then((campaign) => {
        toast.success("Campaign has been updated");
        if (this.state.from === "campaigns") {
          this.props.history.push("/campaigns");
        } else {
          this.props.history.push(
            "/clients/" + this.props.match.params.clientId + "/campaigns"
          );
        }
      })
      .finally(() => {
        this.setState({ loading: false });
      })
  }

  saveSchedules(schedules, campaignId) {
    return new Promise((resolve) => {
      if (!schedules || !schedules.length) return resolve();

      let operations = [];
      schedules.forEach((originalSchedule) => {
        // 保存前的schedule数据
        console.log('[DEBUG] saveSchedules: Processing schedule:', JSON.stringify(originalSchedule, null, 2));
      
        const schedule = JSON.parse(JSON.stringify(originalSchedule));  
        // 提取playlist和playlistCollection的ID
        if (schedule.playlist) {
          if (typeof schedule.playlist === 'object' && schedule.playlist.id) {
            schedule.playlist = schedule.playlist.id;
          } else if (typeof schedule.playlist === 'string') {
            // 已经是ID，保持不变
          } else {
            console.warn('[DEBUG] saveSchedules: Invalid playlist format:', schedule.playlist);
          }
        }
        
        if (schedule.playlistCollection) {
          if (typeof schedule.playlistCollection === 'object' && schedule.playlistCollection.id) {
            schedule.playlistCollection = schedule.playlistCollection.id;
          } else if (typeof schedule.playlistCollection === 'string') {
            // 已经是ID，保持不变
          } else {
            console.warn('[DEBUG] saveSchedules: Invalid playlistCollection format:', schedule.playlistCollection);
          }
        }
        
        schedule.campaign = campaignId;

        // 当从campaigns复制时，确保创建新的schedule而不是更新已存在的
        const searchParams = new URLSearchParams(this.props.location.search);
        const copyFrom = searchParams.get("copyFrom");
        if (!!copyFrom) {
          schedule.id = undefined;
        }

        if (!schedule.id && !schedule.deleted)
          operations.push(API.create("schedules", schedule));

        if (schedule.id && !schedule.deleted)
          operations.push(API.update("schedules", schedule.id, schedule));

        if (schedule.id && schedule.deleted)
          operations.push(API.delete("schedules", schedule.id));
      });

      Promise.all(operations).then(resolve);
    });
  }

  render() {
    if (!this.state.campaign) return <Loader />;
    else
      return (
        <>
          <Head title={"New campaign"} breadcrumb={this.state.breadcrumb} />
          <Content>
            {this.state.loading ? (
              <Loader />
            ) : (
              <CampaignForm
                entity={this.state.campaign}
                devices={this.state.devices}
                collections={this.state.collections}
                parent={this}
                playlists={this.state.playlists}
                livePlaylists={this.state.livePlaylists}
                manualPlaylists={this.state.manualPlaylists}
                cancel={() => {
                  if (this.state.from) {
                    this.props.history.push("/campaigns");
                    return;
                  } else {
                    this.props.history.push(
                      "/clients/" +
                        this.props.match.params.clientId +
                        "/campaigns"
                    );
                  }
                  return;
                }}
                voiceOvers={this.state.voiceOvers}
                save={this.saveEntity}
              />
            )}
          </Content>
        </>
      );
  }
}

export default CampaignsList;
